// Simplified version of core/frontends/app/src/integrations.ts

import {datadogRum} from '@datadog/browser-rum';
import {once} from 'lodash';

export const DATADOG_RUM_APPLICATION_ID =
  '70585d24-006d-424f-a3c5-fbe0403f9ebf';
export const DATADOG_CLIENT_TOKEN = 'pub44b08232e19f1a1651a49e62607b9fcd';
export const DATADOG_SITE = 'us5.datadoghq.com';
export const DATADOG_UI_SERVICE = 'wandb-web-ui';

// This is a subset of the viewer type in state/viewer/types.ts in APP
// This is used in window.ts in app folder and we also need to define it here so tsc doesn't complain.
// Because we are importing `useDatadogRum` from app as a one-off, tsc will complain about the call to
// `window.viewer?.org` in app/src/util/datadog/wrapper.ts.
export type GlobalViewer = {
  id: string;
  username?: string;
  entity: string;
  org?: string;
};

declare global {
  interface Window {
    // This matches what's in app/src/util/window.ts
    viewer: GlobalViewer | undefined;
  }
}

const doDatadogRumInit = once(() => {
  datadogRum.init({
    // TODO(np): get and append username from env
    env: window.WEAVE_CONFIG.DD_ENV,
    applicationId: DATADOG_RUM_APPLICATION_ID,
    clientToken: DATADOG_CLIENT_TOKEN,
    site: DATADOG_SITE,
    service: DATADOG_UI_SERVICE,
    version: (window as any).CONFIG.GIT_TAG,
    trackUserInteractions: true,
    trackLongTasks: true,
    trackResources: true,
    allowedTracingUrls: [
      // local dev
      'http://api.wandb.test',
      'https://api.wandb.test',
      'https://weave.wandb.test',

      // qa
      'https://api.qa.wandb.ai',
      'https://weave.qa.wandb.ai',

      // prod
      'https://api.wandb.ai',
      'https://weave.wandb.ai',
    ].map(url => ({match: url, propagatorTypes: ['b3multi']})),
    defaultPrivacyLevel: 'mask-user-input',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
  });
});

function datadogInit() {
  if (window.WEAVE_CONFIG.ANALYTICS_DISABLED) {
    return;
  }
  doDatadogRumInit();
}

export type DDUserInfoType = {
  username?: string;
  name?: string;
};
export function datadogSetUserInfo(userInfo: DDUserInfoType) {
  datadogInit();
  datadogRum.setUser({
    id: userInfo.username,
    name: userInfo.name,
  });
  if (userInfo.username) {
    datadogRum.startSessionReplayRecording();
  }
}
